import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '../../atoms'
import {
  AmenitiesErrorContainer,
  ErrorTitle,
  AmenitiesErrorMessage,
} from './Amenities.styles'

export interface AmenitiesErrorProps {
  error: string
  onRetry?: () => void
  className?: string
}

/**
 * AmenitiesError component displays an error state when amenities data fails to load.
 * Optionally provides a retry button if an onRetry callback is provided.
 *
 * @param error - Error message to display
 * @param onRetry - Optional callback function to retry loading data
 * @param className - Optional CSS class name
 */
export const AmenitiesError: React.FC<AmenitiesErrorProps> = ({
  error,
  onRetry,
  className,
}) => {
  const { t } = useTranslation('amenities')

  return (
    <AmenitiesErrorContainer className={className}>
      <Icon name="warning" size="large" color="#ff3b30" />
      <ErrorTitle>{t('error.title')}</ErrorTitle>
      <AmenitiesErrorMessage>{error}</AmenitiesErrorMessage>
      {onRetry && (
        <Button variant="primary" size="medium" onClick={onRetry}>
          <Icon name="refresh" size="small" />
          {t('error.retry')}
        </Button>
      )}
    </AmenitiesErrorContainer>
  )
}

export default AmenitiesError
